import api from './api';

export interface Planner {
  id: string;
  wedding_id: string;
  name: string;
  email: string | null;
  color: string | null;
  created_at: string;
}

export const getPlanners = () => api.get<Planner[]>('/planners');
export const createPlanner = (data: { name: string; email?: string | null; color?: string | null }) =>
  api.post<Planner>('/planners', data);
export const updatePlanner = (id: string, data: { name?: string; email?: string | null; color?: string | null }) =>
  api.put<Planner>(`/planners/${id}`, data);
export const deletePlanner = (id: string) => api.delete(`/planners/${id}`);
